import React from "react";
import store from "./state/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { useAppSelector } from "./state/store";
import MaterialProvider from "./MaterialProvider";
import MainRouter from "./pages/MainRouter";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CssBaseline from "@mui/material/CssBaseline";
import { ErrorHandler } from "./components/ErrorHandler";
import "./App.scss";
import { useBqaTheme } from "./hooks/theme";

export default function App() {
  return (
    <Provider store={store}>
      <ApplicationProvider />
    </Provider>
  );
}

export const ApplicationProvider = () => {
  const settings = useAppSelector((state) => state.settings);
  const theme = useBqaTheme(settings.lightMode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div
          className={`app ${settings.lightMode ? "light-mode" : "dark-mode"}`}
        >
          <main>
            <MaterialProvider>
              <BrowserRouter>
                <ErrorHandler>
                  <MainRouter />
                </ErrorHandler>
              </BrowserRouter>
            </MaterialProvider>
          </main>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
};
